import { BACKEND_URL } from "../lib/api";
import { toast } from "sonner";

export async function downloadCustomerReceipt(customer_id, customer_name = "guest") {
  try {
    const token = localStorage.getItem("ayame_token");
    const res = await fetch(`${BACKEND_URL}/api/staff/customers/${customer_id}/receipt`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) throw new Error("PDF error");
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `ayame-receipt-${customer_name}.pdf`;
    a.click();
    URL.revokeObjectURL(url);
    toast.success("Receipt downloaded");
  } catch {
    toast.error("Could not download PDF");
  }
}
